
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { findCurrent as findCurrentUsage } from 'subscriptions/usage/quick/actions';
import { getCurrentQuickUsage } from 'reducers';

import ListItem from 'subscriptions/ListItem';
import * as routes from 'app/routes';

class QuickListItemComponent extends Component {
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    if (this.props.subscription.id !== oldProps.subscription.id) {
      this.fetchData();
    }
  }

  fetchData() {
    const { subscription, findCurrentUsage } = this.props;
    if (subscription) {
      findCurrentUsage(subscription.id);
    }
  }

  render() {
    return <ListItem {...this.props} carrier="quick" />
  }
}

const mapStateToProps = (state, { subscription }) => {
  const usage = getCurrentQuickUsage(state, subscription.id);
  return {
    usage,
  }
};

const mapDispatchToProps = {
  findCurrentUsage,
  subRoute: routes.quickSubscription,
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuickListItemComponent);